import React from "react";

function NotFoundPage() {
  return <div>존재하지 않는 페이지입니다.</div>;
}

export default NotFoundPage;
